import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CTX = createContext(null);
const ADMIN_USER = "admin";
const ADMIN_PASS = "Hercules23@";

export function AuthProvider({ children }) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const persisted = localStorage.getItem("hercules_admin_auth");
    setIsAdmin(persisted === "true");
  }, []);

  useEffect(() => {
    localStorage.setItem("hercules_admin_auth", isAdmin ? "true" : "false");
  }, [isAdmin]);

  const login = (user, pass) => {
    if (user === ADMIN_USER && pass === ADMIN_PASS) {
      setIsAdmin(true);
      toast.success("Login efetuado. Bem-vindo, admin!");
      return true;
    }
    toast.error("Credenciais inválidas");
    return false;
  };

  const logout = () => {
    setIsAdmin(false);
    toast.info("Sessão encerrada");
  };

  const value = useMemo(() => ({ isAdmin, login, logout }), [isAdmin]);
  return <CTX.Provider value={value}>{children}</CTX.Provider>;
}

export function useAuth() {
  const ctx = useContext(CTX);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
